import { notFound } from '../not-found'

export const PARALLEL_ROUTE_DEFAULT_PATH =
  'next/dist/client/components/builtin/default.js'

export default function ParallelRouteDefault() {
  notFound()
}
